<template>
  <div class="elevation-3 ma-3 pa-3 tmc-crud-list-root" ref="crudListRoot" tabindex="-1">
    <v-data-table
      v-model="selectedTasks"
      :item-key="itemKey"
      :headers="headers"
      :items="itemsGetter"
      :items-per-page.sync="getSettings.itemsperpage"
      :server-items-length="getSettings.serverItemsLength"
      :footer-props="getSettings.footerProps"
      @update:options="handleOptions"
      :options="headersWithColsSpan"
      dense
      :show-expand="showExpand"
      :expanded.sync="expanded"
      :show-select="showSelect"
      :loading="loadingData"
      :fixed-header="enableFixedHeaders"
      :height="tableDynamicHeight"
      :loading-text="loadingText"
      :hide-default-footer="hideDefaultFooter"
      :disable-pagination="disablePagination"
      class="elevation-1"
    >
    <template v-slot:header="{ props }">
      <thead class="v-data-table-header" >
              <tr>
                <th v-for="data in props.options.mainHeadName"
                :key="data.id" :colspan="data.cols"
                :class="['text-center parent-header', data.cellClass]">
                  {{ data.text }}
                </th>
              </tr>
            </thead>
    </template>
    <template v-slot:top="{ pagination, options, updateOptions }">
      <v-row>
        <v-col cols="7">
          <div
            style="padding: 12px; display: flex; gap: 60px; align-items: center;
            justify-content: space-between; font-size: 16px; font-weight: 500; color: red;"
          >
            <p v-html="toolbarContent" style="margin: 0;"></p>
          </div>
        </v-col>
        <v-col cols="5">
          <v-toolbar
        v-if="displayTopPagination"
        flat
        class="mr-0 pr-0"
      >
        <div>
          <v-data-footer
            :pagination="pagination"
            :options="options"
            @update:options="updateOptions"
            v-bind="getSettings.footerProps"
            items-per-page-text="$vuetify.dataTable.itemsPerPageText"
            :items-per-page.sync="getSettings.itemsperpage"
            :server-items-length="getSettings.serverItemsLength"
          />
        </div>
      </v-toolbar>
        </v-col>
      </v-row>
      <Toolbar :toolbarTitle="toolbarTitle">
        <template v-slot:[`additionalTools`]="{}">
          <slot name="additionalTools">
            <!-- can override to show other tools here -->
          </slot>
        </template>
        <template v-slot:[`selectDate`]="{}">
          <slot name="selectDate">
          </slot>
        </template>
        <template v-slot:activator="{}">
          <slot name="activator">
            <!-- can override to show other tools here -->
          </slot>
        </template>
        <template v-slot:[`bulkMarking`]="{}">
          <slot name="bulkMarking">
            <!-- can override to show other tools here -->
          </slot>
        </template>
        <template v-slot:[`duplicateMarking`]="{}">
          <slot name="duplicateMarking">
            <!-- can override to show other tools here -->
          </slot>
        </template>
        <template v-slot:[`canDeleteSlot`]="{}">
          <slot name="canDeleteSlot">
            <!-- can override to show other tools here -->
          </slot>
        </template>
        <template v-slot:[`additionalToolsAtRight`]="{}">
          <slot name="additionalToolsAtRight">
            <!-- can override to show other tools here -->
          </slot>
        </template>
        <template v-slot:[`canAddSlot`]="{}">
          <v-divider
            class="mx-4" inset vertical
          ></v-divider>
          <v-btn
            id="add-new-base-item"
            v-if="canAdd"
            class="mx-2" color="primary"
            fab icon small
            @click="handleNewItem"
            :disabled="isVisibleProp"
          >
            <v-icon>
              {{icons.mdiPlus}}
            </v-icon>
          </v-btn>
          <!-- TODO - multi-select support
          :disabled="selectedProp.length !== 0"
          -->
          <CRUDDialog
            ref="crudDialog"
            :baseCrudKey="baseCrudKey"
            :canSave="canSave"
            :canApply="canApply"
            :overrideApplyBtnLabel="overrideApplyBtnLabel"
            :overRideDialogTitle="overRideDialogTitle"
            @upsertItem="emitUpsertItem"
          >
            <template v-slot:[`editedItem`]="{}">
              <slot name="editedItem">
                <v-container>
                  <!-- you should always override to show how to edit the item -->
                  <span>(this is the default template)</span>
                </v-container>
              </slot>
            </template>
            <template v-slot:[`additionalActions`]="{}">
              <slot name="additionalActions"/>
            </template>
            <template v-slot:[`additionalActionTitle`]="{}">
              <slot name="additionalActionTitle"/>
            </template>
            <template v-slot:[`additionalActionsAfterSave`]="{}">
              <slot name="additionalActionsAfterSave"/>
            </template>
          </CRUDDialog>
        </template>
      </Toolbar>
    </template>

    <template v-slot:[`item`]="{ item, headers }">
      <Row
        :showSelect="showSelect"
        :selectedItems="selectedTasks"
        :canEdit="canEdit"
        :canDelete="canDelete"
        :item="item"
        :headers="headers"
        :uploadFileParams="uploadFileParams"
        :showExpand="showExpand"
        :expanded="expanded"
        @editItem="handleEditItem"
        @emitSelectedItem="handleSelectedTasks"
        @emitDeleteRowItem="deleteRowItem"
        @toggleExpandableRowItem="toggleExpandableRowItem"
      />
    </template>
      <template v-if="showExpand" v-slot:expanded-item="{ item }">
        <td :colspan="headers.length">
          <CRUDExpandableRow
            :item="item"
            :baseCrudKey="baseCrudKey"
          />
        </td>
      </template>
      <template
        v-slot:footer
        v-if="isShowTotal">
        <br/>
        <ListTotal
        :itemTotal="itemTotal"
        :customItemTotal="customItemTotal"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {
  mdiPlus,
} from '@mdi/js';
import {
  mapGetters,
  mapMutations,
} from 'vuex';
import { isInsert } from '../../../../util/shared/vue-global';

import CRUDDialog from './CRUDDialog.vue';
import Toolbar from './CRUDToolbar.vue';
import Row from './CRUDRow.vue';
import ListTotal from './CRUDListTotal.vue';
import CRUDExpandableRow from './CRUDExpandableRow.vue';
import { getWorkstationNumber } from '../../../../util/workstation-util';

export default {
  name: 'CRUDList',
  components: {
    CRUDDialog,
    Toolbar,
    Row,
    ListTotal,
    CRUDExpandableRow,
  },
  props: {
    toolbarContent: {
      type: String,
      default: '',
    },
    toolbarTitle: {
      type: String,
      default: 'Items',
    },
    itemKey: {
      type: String,
      default: '_id',
    },
    baseCrudKey: {
      type: String,
      default: 'default',
    },
    // the calling component has to tell us how to make a new item
    createNewItem: {
      type: Function,
      default: () => ({}),
    },
    headers: {
      type: Array,
      default: () => ([]),
    },
    headersWithColsSpan: {
      type: Object,
      default: () => ({}),
    },
    enableFixedHeaders: {
      type: Boolean,
      default: false,
    },
    tableDynamicHeight: {
      type: String,
    },
    dataMapper: {
      type: Function,
      default: (itemData) => itemData,
    },
    defaultSortBy: {
      type: Array,
      default: () => undefined,
    },
    canAdd: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    canDelete: {
      type: Boolean,
      default: false,
    },
    canSave: {
      type: Boolean,
      default: true,
    },
    canApply: {
      type: Boolean,
      default: false,
    },
    // if you don't want previous criteria pass false
    mergeCriteria: {
      type: Boolean,
      default: true,
    },
    uploadFileParams: {
      type: Object,
      default: () => ({}),
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
    selectedItems: {
      type: Array,
      default: () => ([]),
    },
    itemTotal: {
      type: Number,
      default: 0,
    },
    showTotal: {
      type: Boolean,
      default: false,
    },
    showExpand: {
      type: Boolean,
      default: false,
    },
    loadingData: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: '',
    },
    customItemTotal: {
      type: String,
      default: '',
    },
    displayTopPagination: {
      type: Boolean,
      default: true,
    },
    disablePagination: {
      type: Boolean,
      default: false,
    },
    hideDefaultFooter: {
      type: Boolean,
      default: false,
    },
    overrideApplyBtnLabel: {
      type: String,
      default: '',
    },
    overRideDialogTitle: {
      type: String,
      default: '',
    },
    showCancelBtn: {
      type: Boolean,
      default: true,
    },
    keepTheDialogPersistent: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    icons: {
      mdiPlus,
    },
    expanded: [],
  }),
  computed: {
    ...mapGetters('user', [
      'getSettings',
    ]),
    ...mapGetters('base/crud', [
      'items',
      'skipLimitPage',
      'isVisible',
    ]),
    selectedTasks: {
      get() {
        return this.selectedItems || [];
      },
      set(value) {
        this.$emit('emitSelectedItem', value);
      },
    },
    itemsGetter() {
      const itemData = this.items(this.baseCrudKey);
      return this.dataMapper(itemData);
    },
    isVisibleProp() {
      const visibleFlag = this.isVisible(this.baseCrudKey);
      if (visibleFlag === undefined) {
        return false;
      }
      return visibleFlag;
    },
    isShowTotal() {
      return this.showTotal && (this.itemTotal !== 0 || this.customItemTotal);
    },
  },
  watch: {
    isVisibleProp(isVisible, wasVisible) {
      if (wasVisible && !isVisible) this.parkFocusOnList();
    },
  },
  created() {
    // first page default
    // const merge = true;
    const criteria = this.skipLimitPage(1);
    this.setCriteria([this.baseCrudKey, criteria, this.mergeCriteria]);
    // this.emitLoadCRUDList();
    // https://www.raymondcamden.com/2019/08/12/working-with-the-keyboard-in-your-vue-app
    window.addEventListener('keydown', this.shortcutHandler);
  },
  destroyed() {
    // https://stackoverflow.com/a/10444156/10567369
    window.removeEventListener('keydown', this.shortcutHandler);
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
      'setItem',
      'setIndex',
      'setIsVisible',
    ]),
    ...mapMutations(['setWkstDialog']),
    handlePage(page) { // To be remove - when 'handleOptions' become stable
      const merge = true;
      const criteria = this.skipLimitPage(page);
      this.setCriteria([this.baseCrudKey, criteria, merge]);
      this.emitLoadCRUDList();
    },
    buildSortCriteria(sortByOptions, sortDesc) {
      let sortBy = [];
      if (sortByOptions.length > 0 && sortDesc.length > 0
        && sortByOptions.length === sortDesc.length) {
        for (let i = 0; i < sortDesc.length; i += 1) {
          sortBy.push({
            column: sortByOptions[0],
            direction: sortDesc[0] ? 'desc' : 'asc',
          });
        }
      } else if (sortDesc.length === 0 || sortByOptions.length === 0) {
        if (!this.defaultSortBy) {
          console.warn('no default sortBy is set');
        }
        // default sort
        sortBy = this.defaultSortBy || [
          { column: '_id', direction: 'desc' },
        ];
      }
      return sortBy;
    },
    handleOptions(options) {
      const merge = true;
      const { sortBy: sortByOptions, sortDesc, page } = options;
      const paginationCriteria = this.skipLimitPage(page);
      const sortByCriteria = this.buildSortCriteria(sortByOptions, sortDesc);
      const criteria = { ...paginationCriteria, sortBy: sortByCriteria };
      this.setCriteria([this.baseCrudKey, criteria, merge]);
      this.emitLoadCRUDList();
    },
    handleDialogScrolling() {
      this.$nextTick(() => {
        const accessMultipleDialogBox = document.querySelectorAll('.v-dialog.v-dialog--active');
        for (let i = 0; i < accessMultipleDialogBox.length; i += 1) {
          accessMultipleDialogBox[i].scrollTop = 0;
        }
      });
    },
    // Vuetify's VDialog restores focus to whatever was focused when the dialog opened -
    // the Add (+) button, or the row's edit pencil. Both are buttons, and Enter on a
    // button presses it, so the very keystroke that saved a record could go on to open
    // a blank new one (Tulsa Mtg Tax, 9/16). Park focus on the list itself instead.
    // The nextTick is what puts us after VDialog's own focus() call, which runs while
    // the isVisible change is still being flushed.
    parkFocusOnList() {
      this.$nextTick(() => {
        // closed and reopened within the same flush - leave the new dialog alone
        if (this.isVisibleProp) return;
        const active = document.activeElement;
        // something else (a nested dialog, a menu) took focus on purpose
        if (active && typeof active.closest === 'function' && active.closest('.v-dialog--active')) return;
        const root = this.$refs.crudListRoot;
        if (root && typeof root.focus === 'function') root.focus({ preventScroll: true });
      });
    },
    handleNewItem() {
      /* Before opening a dialog, check that wkst is set or not? */
      const wkst = getWorkstationNumber();
      if (wkst) {
        const newItem = this.createNewItem();
        this.setItem([this.baseCrudKey, newItem]);
        this.setIndex([this.baseCrudKey, -1]);
        this.setIsVisible([this.baseCrudKey, true]);
        this.emitActivateItem(newItem);
        this.handleDialogScrolling();
      } else {
        this.setWkstDialog(true);
      }
    },
    handleEditItem(item) {
      const index = this.itemsGetter.indexOf(item);
      this.setItem([this.baseCrudKey, { ...item }]);
      this.setIndex([this.baseCrudKey, index]);
      this.setIsVisible([this.baseCrudKey, true]);
      this.emitActivateItem(item);
      this.handleDialogScrolling();
    },
    emitActivateItem(item) {
      this.$emit('activateItem', item);
    },
    emitLoadCRUDList() {
      this.$emit('loadCRUDList');
    },
    emitUpsertItem(item) {
      this.$emit('upsertItem', item);
    },
    // emitSelectedItem(item) {
    // },
    shortcutHandler(e) {
      if (this.canAdd && isInsert(e) && !this.isVisibleProp) {
        this.handleNewItem();
        // important as per v-dialog documentation
        e.stopPropagation();
      }
    },
    handleSelectedTasks(value) {
      this.selectedTasks = value || [];
    },
    toggleExpandableRowItem(item) {
      const itemId = item._id;
      const filteredItem = (this.expanded || []).find((t) => t._id === itemId);
      if (!filteredItem) {
        this.expanded.push(item);
      } else {
        this.expanded = (this.expanded || []).filter((t) => t._id !== itemId);
      }
    },
    deleteRowItem(item) {
      this.$emit('emitDeleteRowItem', item);
    },
  },
};
</script>

<style lang="sass">
// focusable only so the dialog can hand focus back to something inert on close
// (see parkFocusOnList) - it is never a tab stop, so it must not look focused
.tmc-crud-list-root:focus
  outline: none

// overriding default VDataTable Margins
.v-data-table
  > .v-data-footer
    margin-right: 21px
    > .v-data-footer__select
      margin-right: 18px
    > .v-data-footer__icons-before
      margin-right: 9px
    > .v-data-footer__icons-after
      margin-left: 4px
</style>
